import { Col, Divider, Row, Typography } from 'antd'
import React from 'react'
import { Link } from 'react-router-dom'
import { HeaderComp, RegionMap, Spiner } from '../../components'
import Mal from "../../assets/mal.png"
import { useQuery } from '@apollo/client'
import { GET_LOCATIONS } from '../../Graphql/queries/getQueries'

const OverviewVisitors = () => {
    const { loading, data } = useQuery(GET_LOCATIONS, { variables: { count: 100 } })
    // const reducerCountry = () => {
    //     let countries = {}
    //     data?.Leads?.nodes?.map((item) => item.country).forEach(country => {
    //         if (!countries[country]) {
    //             countries = { ...countries, [country]: 1 }
    //         } else {
    //             countries = {
    //                 ...countries, [country]: countries[country] + 1
    //             }
    //         }

    //     });
    //     let countryArr = []
    //     for (const country in countries) {
    //         countryArr.push({ [country]: countries[country] })
    //     }
    //     console.log(countryArr)
    //     return countries
    // }
    // reducerCountry()

    const visitors = new Array(6).fill(0)
    return (
        <div className="item_comp"   >
            <HeaderComp title="Visitors online" />
            <Row gutter={[16, 16]}>
                <Col style={{ minHeight: 500 }} lg={16} xs={24}  >
                    {loading ? <Spiner /> : <RegionMap loading={loading} data={data} />}
                </Col>
                <Col lg={8} xs={24} >
                    <div style={{
                        background: "#ffffff",
                        boxShadow: " 0px 10px 20px #c4c8d066",
                        borderRadius: "8px",
                        padding: 30
                    }}>
                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <Typography.Title level={1}> 93</Typography.Title>
                            <Typography.Text style={{ color: 'gray' }} level={6}>Visitors online</Typography.Text>
                        </div>
                        <Divider style={{ width: "100%" }} />
                        {visitors.map((e, i) => (
                            <div key={i} style={{ display: "flex", flexDirection: "column" }}>
                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                    <div>
                                        <img src={Mal} style={{ width: 35, height: 25, marginRight: 10 }} alt="" />
                                        <Typography.Text level={6}>Malaysia</Typography.Text>
                                    </div>
                                    <Typography.Text style={{ color: 'gray' }} level={6}>35</Typography.Text>

                                </div>
                                <Divider style={{ width: "100%", margin: 10 }} />
                            </div>
                        ))}


                        <div style={{ width: "100%", textAlign: "center" }}>
                            <Link style={{ color: "#508FF4" }} to='/'>View full visitors stats</Link>
                        </div>
                    </div>
                </Col>

            </Row>
        </div>
    )
}

export default OverviewVisitors